import React from 'react'
import TabBar from '../../components/Tabbar';

const UploadData = () => {
  return <TabBar />
}

export default UploadData